/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vpn_Feature_5Inputs */

const en_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>No logs policy</a>`)
};

const id_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>Tidak ada kebijakan log</a>`)
};

const ms_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>Dasar tiada log</a>`)
};

const ca_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>Política de zero registres</a>`)
};

const cs_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>Zásady nepoužívání protokolů</a>`)
};

const da_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>Ingen politik for logfiler</a>`)
};

const de_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>Keine Protokollierung</a>`)
};

const et_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>Puuduvad logide eeskirjad</a>`)
};

const es_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>Política de cero registros</a>`)
};

const fr_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href=’https://guardianapp.com/policy/service-policies/’>Politique zéro-logs</a>`)
};

const hr_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>Pravila o nečuvanju evidencije</a>`)
};

const it_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>Politica No-Log</a>`)
};

const lv_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>Datu nesaglabāšanas politika</a>`)
};

const lt_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>Nėra žurnalų saugojimo politikos</a>`)
};

const hu_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>Nincs naplózás</a>`)
};

const nl_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>Anti-logsbeleid</a>`)
};

const nb_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>Ingen loggføring</a>`)
};

const pl_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>Polityka bez logów</a>`)
};

const pt_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>Política de não guardar registros</a>`)
};

const ro_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>Politica privind lipsa jurnalelor</a>`)
};

const sk_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>Žiadne uchovávanie záznamov</a>`)
};

const sl_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>Politika brez dnevnikov</a>`)
};

const fi_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>Ei lokeja -käytäntö</a>`)
};

const sv_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>Ingen loggpolicy</a>`)
};

const vi_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>Chính sách không lưu nhật ký</a>`)
};

const tr_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>Log tutmama politikası</a>`)
};

const el_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>Πολιτική μη τήρησης αρχείων καταγραφής</a>`)
};

const bg_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>Политика за липса на логове</a>`)
};

const ru_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>Нет политики логов</a>`)
};

const sr_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>Правила о нечувању евиденције</a>`)
};

const uk_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>Політика Політика незбереження журналів</a>`)
};

const ka_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>ლოგების არარსებობის პოლიტიკა</a>`)
};

const hi_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>नो लोग पालिसी</a>`)
};

const th_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>นโยบายไม่เก็บบันทึก</a>`)
};

const ko_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>로그 미보관 정책</a>`)
};

const zh_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>无日志政策</a>`)
};

const zh_tw_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>無日誌政策</a>`)
};

const ja_vpn_feature_5 = /** @type {(inputs: Vpn_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<a href='https://guardianapp.com/policy/service-policies/'>ノーログポリシー</a>`)
};

/**
* | output |
* | --- |
* | "<a href='https://guardianapp.com/policy/service-policies/'>No logs policy</a>" |
*
* @param {Vpn_Feature_5Inputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const vpn_feature_5 = /** @type {((inputs?: Vpn_Feature_5Inputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vpn_Feature_5Inputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_vpn_feature_5(inputs)
	if (locale === "ms") return ms_vpn_feature_5(inputs)
	if (locale === "ca") return ca_vpn_feature_5(inputs)
	if (locale === "cs") return cs_vpn_feature_5(inputs)
	if (locale === "da") return da_vpn_feature_5(inputs)
	if (locale === "de") return de_vpn_feature_5(inputs)
	if (locale === "et") return et_vpn_feature_5(inputs)
	if (locale === "es") return es_vpn_feature_5(inputs)
	if (locale === "fr") return fr_vpn_feature_5(inputs)
	if (locale === "hr") return hr_vpn_feature_5(inputs)
	if (locale === "it") return it_vpn_feature_5(inputs)
	if (locale === "lv") return lv_vpn_feature_5(inputs)
	if (locale === "lt") return lt_vpn_feature_5(inputs)
	if (locale === "hu") return hu_vpn_feature_5(inputs)
	if (locale === "nl") return nl_vpn_feature_5(inputs)
	if (locale === "nb") return nb_vpn_feature_5(inputs)
	if (locale === "pl") return pl_vpn_feature_5(inputs)
	if (locale === "pt") return pt_vpn_feature_5(inputs)
	if (locale === "ro") return ro_vpn_feature_5(inputs)
	if (locale === "sk") return sk_vpn_feature_5(inputs)
	if (locale === "sl") return sl_vpn_feature_5(inputs)
	if (locale === "fi") return fi_vpn_feature_5(inputs)
	if (locale === "sv") return sv_vpn_feature_5(inputs)
	if (locale === "vi") return vi_vpn_feature_5(inputs)
	if (locale === "tr") return tr_vpn_feature_5(inputs)
	if (locale === "el") return el_vpn_feature_5(inputs)
	if (locale === "bg") return bg_vpn_feature_5(inputs)
	if (locale === "ru") return ru_vpn_feature_5(inputs)
	if (locale === "sr") return sr_vpn_feature_5(inputs)
	if (locale === "uk") return uk_vpn_feature_5(inputs)
	if (locale === "ka") return ka_vpn_feature_5(inputs)
	if (locale === "hi") return hi_vpn_feature_5(inputs)
	if (locale === "th") return th_vpn_feature_5(inputs)
	if (locale === "ko") return ko_vpn_feature_5(inputs)
	if (locale === "zh") return zh_vpn_feature_5(inputs)
	if (locale === "zh-tw") return zh_tw_vpn_feature_5(inputs)
	if (locale === "ja") return ja_vpn_feature_5(inputs)
	return en_vpn_feature_5(inputs)
});